import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheckIcon } from "lucide-react";
import { PoliciesView } from "@/components/policies/policies-view";
import { policiesPageQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/policies/")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureInfiniteQueryData(policiesPageQuery({})));
  },
  component: PoliciesPage,
});

function PoliciesPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <ClipboardCheckIcon className="size-3.5" />
            Policies
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Policy acknowledgments</h1>
          <p className="text-muted-foreground text-sm">
            Publish policies and track who's read and acknowledged them.
          </p>
        </div>

        <PoliciesView />
      </div>
    </main>
  );
}
